import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { DesktopHeaderBottom } from 'components/DesktopHeader/DesktopHeaderBottom';
import { GetTheApp } from 'components/GetTheApp';
import { PreferencesWidgetWithStore } from 'components/PreferencesWidgetWithStore';
import { SearchBoxDesktop } from 'components/SearchBox/Search';
import UserWidget from 'components/UserWidget';
import { getHomeUrlWithUTMParams } from 'utils/utmParams';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Header } from '@daedalus/atlas/Header';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { selectIsAuthenticated, selectIsLoading } from '@daedalus/core/src/auth/modules/selectors';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import { isReactNativeWebView } from '@daedalus/core/src/native';
import { BrandLogo } from '@daedalus/shared/src/whiteLabel/BrandLogo/BrandLogo';
const _exp2 = /*#__PURE__*/() => ({
  isFullWidth
}) => isFullWidth ? 1 : 0;
const SearchBoxDesktopWrapped = /*#__PURE__*/styled('div')({
  name: "SearchBoxDesktopWrapped",
  class: "ssa2jtv",
  propsAsIs: false,
  vars: {
    "ssa2jtv-0": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => Flex.Row;
const RightComponentWrapper = /*#__PURE__*/styled(_exp3())({
  name: "RightComponentWrapper",
  class: "r1xc1fyc",
  propsAsIs: true
});
interface Props {
  /** Whether to show the search form in the header */
  hasSearchForm?: boolean;
  /** Whether to show the filters bar in the header */
  hasFilters?: boolean;
  /** Custom component to override default search box */
  customSearchBox?: React.ReactElement;
}
export const DesktopHeaderContent = ({
  hasSearchForm,
  hasFilters = false,
  customSearchBox
}: Props) => {
  const {
    brandHasCollapsingHeader,
    brandShowSignIn,
    brand,
    brandIsVio
  } = useBrand();
  const {
    isDesktopSm,
    isDesktopXs
  } = useDeviceLayout();
  const searchBoxShouldMoveToBottomComponent = Boolean(isDesktopXs || isDesktopSm || brandHasCollapsingHeader) && hasSearchForm;
  const logoURL = getHomeUrlWithUTMParams();
  const hasTopHeader = brandHasCollapsingHeader;
  const hasMainHeader = !brandHasCollapsingHeader || hasSearchForm;
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoading = useSelector(selectIsLoading);
  const isWebView = isReactNativeWebView();
  const showGetTheAppButton = brandIsVio && !isWebView && !hasSearchForm && !isAuthenticated && !isLoading;
  return <>
      {hasTopHeader && <Header showLogo brand={brand} RightComponent={<RightComponentWrapper gap="s300">
              <PreferencesWidgetWithStore />
              {brandShowSignIn && <UserWidget />}
            </RightComponentWrapper>} hasDivider logoUrl={logoURL} showTopContent isCompact BrandLogoComponent={BrandLogo} />}
      {hasMainHeader && <Header showLogo={!brandHasCollapsingHeader} brand={brand} CenterComponent={hasSearchForm && !searchBoxShouldMoveToBottomComponent && <SearchBoxDesktopWrapped isFullWidth={brandHasCollapsingHeader}>
                {customSearchBox ? customSearchBox : <SearchBoxDesktop />}
              </SearchBoxDesktopWrapped>} RightComponent={!brandHasCollapsingHeader ? <RightComponentWrapper gap="s300">
                {showGetTheAppButton && <GetTheApp dataId="desktop_top_bar_home_page" placement={Placement.MenuItem} />}
                <PreferencesWidgetWithStore />
                {brandShowSignIn && <UserWidget />}
              </RightComponentWrapper> : null} BottomComponent={<DesktopHeaderBottom hasSearchBox={searchBoxShouldMoveToBottomComponent} hasFilters={hasFilters} customSearchBox={customSearchBox} />} hasDivider={hasSearchForm || !brandHasCollapsingHeader} logoUrl={logoURL} showTopContent={!brandHasCollapsingHeader} BrandLogoComponent={BrandLogo} />}
    </>;
};

require("./DesktopHeaderContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./DesktopHeaderContent.tsx");